/**
 * Template Registry
 * Maps template IDs from the database to React components
 */
import { SLCClassic, SLCModern } from './slc/SLCTemplates';
import { TCClassic, TCModern } from './tc/TCTemplates';
import { BonafideClassic, BonafideModern } from './bonafide/BonafideTemplates';

// Template ID → Component mapping
const TEMPLATE_REGISTRY = {
  // SLC templates
  SLC_DEFAULT_01: SLCClassic,
  SLC_MODERN_01: SLCModern,

  // TC templates
  TC_DEFAULT_01: TCClassic,
  TC_MODERN_01: TCModern,

  // Bonafide templates
  BONAFIDE_DEFAULT_01: BonafideClassic,
  BONAFIDE_MODERN_01: BonafideModern,

  // Result templates (placeholder - to be built)
  RESULT_DEFAULT_01: null,
  RESULT_MODERN_01: null,

  // Report Card templates (placeholder - to be built)
  RC_DEFAULT_01: null,
  RC_MODERN_01: null,
};

/**
 * Get the template component for a given template ID
 * Falls back to the first available template for the doc type
 */
export function getTemplateComponent(templateId) {
  return TEMPLATE_REGISTRY[templateId] || null;
}

/**
 * Get default template component for a doc type
 */
export function getDefaultTemplate(docType) {
  const defaults = {
    SLC: SLCClassic,
    TC: TCClassic,
    BONAFIDE: BonafideClassic,
  };
  return defaults[docType] || null;
}

export default TEMPLATE_REGISTRY;
